export default __webpack_public_path__ + "images/segment_success_illustration.20b6fe64cc0e59b2b57ebb20f458ff1d.svg";